import {Component, Inject, OnInit} from '@angular/core';
import {TestExecution} from '../../../data/models/execution/test-execution';
import {TestExecutionService} from '../../../services/api/execution/test-execution.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-execution-finish-dialog',
  templateUrl: './test-execution-finish-dialog.component.html',
  styleUrls: ['./test-execution-finish-dialog.component.css']
})
export class TestExecutionFinishDialogComponent implements OnInit {

  execution: TestExecution;
  testType: String;

  constructor(
    private testExecutionService: TestExecutionService,
    public dialogRef: MatDialogRef<TestExecutionFinishDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      execution: TestExecution,
      testType: String,
    },
  ) {
    this.execution = data.execution;
    this.testType = data.testType;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testExecutionService.finishTestExecution(this.execution.id)
      .then(execution => this.dialogRef.close(execution));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
